// What the app's shell lends the views drawn in it: the date range and how
// to change it, and the drawer's collapse, for the workspace mode, which
// says them in its own places rather than in the shell's topbar (the
// sidebar's head, the board's bar). Null outside a shell that lends them.
import { createContext, useContext } from "react";

export const ShellControls = createContext(null);

export function useShellControls() {
  return useContext(ShellControls);
}
